<div class="forgot-shell">
  <div class="forgot-shell-overlay"></div>

  <div class="forgot-wrapper">
    <form class="forgot-form">
      <mat-card class="forgot-card">
        <div class="forgot-grid">
          <section class="brand-panel">
            <div class="brand-content">
              <img [src]="logo()" alt="Logomarca da empresa" class="company-logo">
              <h1>Esqueceu a sua senha?</h1>
              <p>
                Siga os passos para validar seu cadastro, confirmar o código enviado por e-mail e definir uma nova senha.
              </p>
            </div>
          </section>

          <section class="content-panel">
            <div class="forgot-header">
              <h2>Recuperação de Senha</h2>
              <p>Informe os dados solicitados para recuperar o seu acesso.</p>
            </div>

            <mat-vertical-stepper [linear]="true" class="password-stepper">
              <mat-step errorMessage="Informe um CPF ou CNPJ válido" [stepControl]="sendResetEmailForm">
                <ng-template matStepLabel>
                  <mat-icon>person</mat-icon>
                  Informe o CPF ou CNPJ
                </ng-template>
                <div class="step-content">
                  <p class="step-description">Digite seu CPF ou CNPJ para receber o código de verificação por e-mail.</p>
                  <form [formGroup]="sendResetEmailForm">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>CPF ou CNPJ</mat-label>
                      <mat-icon matPrefix>person</mat-icon>
                      <input
                        matInput
                        type="text"
                        formControlName="documento"
                        mask="000.000.000-00||00.000.000/0000-00"
                        autocomplete="username"
                        placeholder="Digite seu CPF ou CNPJ">
                      <mat-error *ngIf="sendResetEmailForm.get('documento')?.hasError('required')">
                        CPF ou CNPJ é obrigatório
                      </mat-error>
                    </mat-form-field>
                    <div class="step-actions">
                      <span class="step-hint">Enviaremos o código para o e-mail cadastrado.</span>
                      <button
                        mat-raised-button
                        color="primary"
                        matStepperNext
                        [disabled]="!sendResetEmailForm.valid"
                        (click)="validateDocumentClick()"
                        class="step-button">
                        <mat-icon>arrow_forward</mat-icon>
                        <span>Enviar código</span>
                      </button>
                    </div>
                  </form>
                </div>
              </mat-step>

              <mat-step errorMessage="Código de verificação inválido" [stepControl]="validateCodeForm">
                <ng-template matStepLabel>
                  <mat-icon>mail</mat-icon>
                  Código de verificação
                </ng-template>
                <div class="step-content">
                  <p class="step-description">Verifique seu e-mail e digite o código de 6 dígitos enviado.</p>
                  <form [formGroup]="validateCodeForm">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Código de Verificação</mat-label>
                      <mat-icon matPrefix>lock</mat-icon>
                      <input
                        matInput
                        type="text"
                        formControlName="code"
                        maxlength="6"
                        placeholder="Digite o código de 6 dígitos">
                      <mat-error *ngIf="validateCodeForm.get('code')?.hasError('required')">
                        Código é obrigatório
                      </mat-error>
                    </mat-form-field>
                    <div class="step-actions step-actions-split">
                      <button
                        mat-button
                        matStepperPrevious
                        class="back-button">
                        <mat-icon>arrow_back</mat-icon>
                        Voltar
                      </button>
                      <button
                        mat-raised-button
                        color="primary"
                        matStepperNext
                        [disabled]="!validateCodeForm.valid"
                        (click)="validateEmailCode()"
                        class="step-button">
                        <mat-icon>arrow_forward</mat-icon>
                        <span>Verificar</span>
                      </button>
                    </div>
                  </form>
                </div>
              </mat-step>

              <mat-step errorMessage="Senhas não coincidem" [stepControl]="setNewPasswordForm">
                <ng-template matStepLabel>
                  <mat-icon>vpn_key</mat-icon>
                  Nova senha
                </ng-template>
                <div class="step-content">
                  <p class="step-description">Defina sua nova senha segura.</p>
                  <form [formGroup]="setNewPasswordForm">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Nova Senha</mat-label>
                      <mat-icon matPrefix>lock</mat-icon>
                      <input
                        matInput
                        [type]="hidePassword ? 'password' : 'text'"
                        formControlName="newPassword"
                        placeholder="Digite sua nova senha">
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        (click)="hidePassword = !hidePassword"
                        [attr.aria-label]="'Mostrar senha'"
                        [attr.aria-pressed]="!hidePassword">
                        <mat-icon>{{hidePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                      </button>
                      <mat-error *ngIf="setNewPasswordForm.get('newPassword')?.hasError('required')">
                        Senha é obrigatória
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Confirmar Nova Senha</mat-label>
                      <mat-icon matPrefix>lock</mat-icon>
                      <input
                        matInput
                        [type]="hideConfirmPassword ? 'password' : 'text'"
                        formControlName="newPasswordConfirm"
                        placeholder="Confirme sua nova senha">
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        (click)="hideConfirmPassword = !hideConfirmPassword"
                        [attr.aria-label]="'Mostrar senha'"
                        [attr.aria-pressed]="!hideConfirmPassword">
                        <mat-icon>{{hideConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                      </button>
                      <mat-error *ngIf="setNewPasswordForm.get('newPasswordConfirm')?.hasError('required')">
                        Confirmação é obrigatória
                      </mat-error>
                    </mat-form-field>
                    <div class="step-actions step-actions-split">
                      <button
                        mat-button
                        matStepperPrevious
                        class="back-button">
                        <mat-icon>arrow_back</mat-icon>
                        Voltar
                      </button>
                      <button
                        mat-raised-button
                        color="primary"
                        [disabled]="!setNewPasswordForm.valid"
                        (click)="changePassword()"
                        class="step-button">
                        <mat-icon>check</mat-icon>
                        <span>Redefinir senha</span>
                      </button>
                    </div>
                  </form>
                </div>
              </mat-step>
            </mat-vertical-stepper>
          </section>
        </div>

        <footer class="forgot-footer">
          <p>
            Lembrou sua senha?
            <a [routerLink]="['/login']" class="login-link">Fazer login</a>
          </p>
        </footer>
      </mat-card>
    </form>
  </div>

  <ngx-spinner></ngx-spinner>
</div>
